<div class="error-page-container">
    <img [src]="url">
</div>